import deleteStakeholder from "../../../store/documentShow/actions/deleteStakeholder";
import { moveStakeholderUp } from "../../../store/documentUpdate/actions/moveStakeholderUp";
import { moveStakeholderDown } from "../../../store/documentUpdate/actions/moveStakeholderDown";
import { IonItem, useIonAlert, IonLabel, IonButton, IonIcon, IonButtons } from "@ionic/react";
import { selectSigners } from "../../../store/documentShow/selectors/selectSigners";
import { useDispatch, useSelector } from "react-redux";
import { selectDocumentStatus } from "../../../store/documentShow/selectors/selectDocumentStatus";
import { arrowUpOutline, arrowDownOutline, trashOutline } from "ionicons/icons";
import UserAvatar from "../../../components/UserAvatar";
import { DocumentStakeholderNotify } from "../../../components/Document/DocumentStakeholderNotify";

const SignersList = () => {
  const dispatch = useDispatch();
  const signers = useSelector(selectSigners);
  const status = useSelector(selectDocumentStatus);

  const [present] = useIonAlert();

  const firstPendingStakeholder = signers.find(({ status }) => status?.code === "pending");

  return (
    <>
      {signers?.map((documentStakeholder, index) => (
        <IonItem key={documentStakeholder.stakeholder?.id} lines="none">
          <UserAvatar user={documentStakeholder.stakeholder}></UserAvatar>
          <IonLabel>
            <h2 style={{ fontWeight: 500 }}>
              {documentStakeholder.stakeholder?.name || "⚠ USUARIO CORRUPTO"}
            </h2>
            <p>{documentStakeholder.status?.name}</p>
          </IonLabel>

          <IonButtons slot="end">
            {status?.code === "pending" &&
              firstPendingStakeholder?.id === documentStakeholder.id && (
                <DocumentStakeholderNotify documentStakeholder={documentStakeholder} />
              )}

            {status?.code === "preparing" && (
              <>
                {index !== 0 && (
                  <IonButton onClick={() => dispatch(moveStakeholderUp(documentStakeholder))}>
                    <IonIcon icon={arrowUpOutline} />
                  </IonButton>
                )}
                {index !== signers.length - 1 && (
                  <IonButton onClick={() => dispatch(moveStakeholderDown(documentStakeholder))}>
                    <IonIcon icon={arrowDownOutline} />
                  </IonButton>
                )}

                <IonButton
                  fill="clear"
                  onClick={() =>
                    present({
                      header: "¿Seguro de quitar al firmante del acuerdo?",
                      buttons: [
                        "volver",
                        {
                          text: "Quitar firmante",
                          handler: (d) => dispatch(deleteStakeholder(documentStakeholder)),
                        },
                      ],
                    })
                  }
                >
                  <IonIcon icon={trashOutline} />
                </IonButton>
              </>
            )}
          </IonButtons>
        </IonItem>
      ))}
    </>
  );
};

export default SignersList;
